module.exports = __webpack_public_path__ + "static/img/wall_left.848da744.png";